import React from 'react';

import Icon from 'views/site/Icon.js';

import Theme from 'styles/Theme.js';
import Utils from 'files/Utils.js';

/*
 * Section / SectionHeader
 *
 * The shared rhythm for every marketing section, matching the storefront's
 * SectionHeader exactly: uppercase accent eyebrow, section heading, one
 * supporting line capped at 640px. Every section opens this way so the page
 * speaks with one voice instead of each section inventing its own.
 *
 * Grounds alternate white and offWhite and nothing else. The page has a dark
 * budget of exactly three things — the trust strip under the hero, the
 * walkthrough call to action, and the footer — and they are all built
 * elsewhere. A section should never introduce a fourth.
 */

export const SectionHeader = ({ align = 'center', eyebrow, style, subtitle, title }) => {

    let centered = align === 'center';

    return (
        <div style={{
            margin: centered ? '0 auto' : 0,
            marginBottom: Utils.isMobile() ? 36 : 48,
            maxWidth: (subtitle && centered) ? 750 : undefined,
            textAlign: align,
            ...style
        }}>
            {eyebrow && (
                <span style={{
                    ...Theme.textStyles.label(),
                    display: 'block',
                    marginBottom: 14
                }}>{eyebrow}</span>
            )}
            <span style={{
                ...Theme.textStyles.sectionHeading({ textAlign: align }),
                display: 'block',
                marginBottom: subtitle ? 16 : 0
            }}>{title}</span>
            {subtitle && (
                <span style={{
                    ...Theme.textStyles.sectionSubheading({ textAlign: align }),
                    display: 'block',
                    margin: centered ? '0 auto' : 0
                }}>{subtitle}</span>
            )}
        </div>
    )
}

// The repeated card unit: white, 16px radius, hairline border, soft shadow,
// icon + title + copy. Used by the hazards, the steps, and the guarantees so
// they are visibly the same kind of thing.
export const InfoCard = ({ copy, icon, title }) => (
    <div style={{
        ...Theme.styles.card(),
        boxShadow: Theme.boxShadow.card,
        padding: Utils.isMobile() ? 24 : 28,
        textAlign: 'left'
    }}>
        <div style={{
            alignItems: 'center',
            display: 'flex',
            gap: 12,
            marginBottom: 10
        }}>
            <Icon name={icon} size={19} color={Theme.colors.primary()} style={{ flexShrink: 0 }} />
            <span style={Theme.textStyles.subHeading({ fontSize: 18 })}>{title}</span>
        </div>
        <span style={{
            ...Theme.textStyles.body({ fontSize: 14 }),
            display: 'block'
        }}>{copy}</span>
    </div>
);

const Section = ({ children, id, narrow, tinted }) => {
    return (
        <section
        id={id}
        style={{
            backgroundColor: tinted === true ? Theme.colors.offWhite : Theme.colors.white,
            width: '100%'
        }}>
            <div style={{
                margin: '0 auto',
                maxWidth: narrow === true ? Theme.layout.readableWidth : Theme.layout.maxWidth,
                padding: Theme.layout.sectionPadding()
            }}>
                {children}
            </div>
        </section>
    )
}

export default Section;
